import * as Yup from 'yup';
import { CommonMessages } from 'src/validation/CommonMessages';

const ClientValidationSchema = Yup.object().shape({

  name: Yup.string()
    .required(CommonMessages.required('Name')),
});

export default ClientValidationSchema;